<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {sTema} from '../stores';
	import {replace} from 'svelte-spa-router';
	import TBox from './templates/TBox.svelte';
	import GradeCartoes from '../componentes/GradeCartoes.svelte';
	import {API, TipoEvento, verificarLocalStorage, verificarSessionStorage} from '../utils';
	import CartaoQuadrado from '../componentes/cartoes/CartaoQuadrado.svelte';

	let icone;
	let tema;
	let exibirAvisoAceiteTermosEdital = true;

	const dispatch = createEventDispatcher();

	const funcionalidadesInicio = () => {
		let opcoes = [
			{ 
				titulo: "Cadastro", 
				icone: "cadastro",
				link: "#/usuario/cadastro"
			},
			{ 
				titulo: "Trabalhos", 
				icone: "trabalhos",
				link: "#/sdg/trabalhos"
				// link: "#/acesso/recuperacao"
			},
			{ 
				titulo: "Suporte", 
				icone: "suporte",
				link: "#/suporte"
			}
		];
		
		if (verificarSessionStorage('AVAL_TOKEN')) {
			opcoes.unshift({
				titulo: "Painel", 
				icone: "painel",
				link: "#/painel"
			})
		} else {
			opcoes.unshift({
				titulo: "Login", 
				icone: "login",
				link: "#/login"
			})
		}

		return opcoes;
	}

	onMount(async () => {
		// verifica se usuario ja confirmou aceite dos termos do edital
		exibirAvisoAceiteTermosEdital = !verificarLocalStorage('CETREINA_CONF_CONS');

		if(exibirAvisoAceiteTermosEdital) replace("#/confirmacao-aceite-termos");

		// definições padrão das configs locais

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			mensagem: 'Configurando aplicação ...',
			valor: true
		});

		tema = $sTema;
		
		if (!tema) {
			tema = "dia";
			localStorage.setItem('AVAL_CONFIG_APP_TEMA', tema);

			sTema.update(novoTema => tema);
		}

		icone = (tema == "dia") ? "logo.png" : "logo-pfe.png";

		// configura app pra usar data atual do cliente como padrão para as requisições de listagem da API
		if (localStorage.getItem('AVAL_CONFIG_APP_ANOBASE') == null)
			localStorage.setItem('AVAL_CONFIG_APP_ANOBASE', new Date().getFullYear());

		// cria cache das informações básicas da API utilizada nos vários componentes
		if (localStorage.getItem('AVAL_API_INFO_CACHE') == null) {
			const resposta = await fetch(API('informacoes')).catch(erros => {
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
	
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Erro',
					conteudo: 'Erro ao recuperar dados, tente novamente.'
				});
			});
			
			let informacoesAPI = await resposta.json();
			
			localStorage.setItem('AVAL_API_INFO_CACHE', JSON.stringify({
				areas_conhecimento: informacoesAPI['areas_conhecimento'],
				modalidades: informacoesAPI['modalidades'],
				unidades: informacoesAPI['unidades_uerj'],
				relatorios_projeto: informacoesAPI['relatorios_projeto'],
				perfis: informacoesAPI['perfis_usuario'],
				anexos_usuario: informacoesAPI['tipos_anexos_usuario'],
				anexos_projeto: informacoesAPI['tipos_anexos_projeto'],
				prazos: informacoesAPI['prazos'],
				cursos: informacoesAPI['cursos'],
				ods: informacoesAPI['ods'],
				tipos_relatorios_sistema: informacoesAPI['tipos_relatorios_sistema'],
				tipos_grupos_sistema: informacoesAPI['tipos_grupos_sistema'],
			}));
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	});
</script>

<TBox 
	subtitulo="Sistema de Cadastro e Avaliação de Projetos"
	iconePng={true}
	tamanhoIcone={128}
	largura={10}
	deslocamento={1}
	exibirBox={false}
	iconePngArquivo={icone}>
	
	<GradeCartoes itens={funcionalidadesInicio()} componente={CartaoQuadrado} />
</TBox>